import { DOMAINS } from "./auth/constants";

const getDomain = () => {
  if (
    typeof window === "undefined" ||
    window.location.hostname === "localhost"
  ) {
    return "";
  }

  const hostname = window.location.hostname;
  const domain = DOMAINS.find((domain) => hostname.includes(domain));

  if (!domain) {
    return "";
  }

  return domain;
};

export const getCookie = (name: string): string | null => {
  const match = document.cookie.match(new RegExp(`${name}=([^;]+)`));
  return match ? match[1] : null;
};

export const setCookie = (name: string, value: string, days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = date.toUTCString();
  const domain = getDomain();

  const cookieParts = [`${name}=${value}`, `expires=${expires}`, `path=/`];

  if (domain) {
    cookieParts.push(`domain=${domain}`);
  }

  document.cookie = cookieParts.join("; ");
};

const deleteHostnameCookie = (name: string) => {
  const expired = "Thu, 01 Jan 1970 00:00:00 UTC";
  const hostname = window.location.hostname;
  const cookieParts = [
    `${name}=`,
    `expires=${expired}`,
    `path=/`,
    `domain=${hostname}`,
  ];

  document.cookie = cookieParts.join("; ");
};

export const deleteCookie = (name: string) => {
  const expired = "Thu, 01 Jan 1970 00:00:00 UTC";
  const domain = getDomain();

  const cookieParts = [`${name}=`, `expires=${expired}`, `path=/`];

  if (domain) {
    cookieParts.push(`domain=${domain}`);
  }

  document.cookie = cookieParts.join("; ");

  // NOTE: 防呆，避免舊資料影響流程
  deleteHostnameCookie(name);
};
